import { ReactNode } from "react";
import { Link } from "react-aria-components";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
import ExternalIcon from "../../../img/icons/external.svg?react";
import { visuallyHidden } from "../../../styles/utils.css";
import { externalLinkIcon } from "../links.css";
import { isPLLink } from "../utils";
import { elementNewsLinkStyles } from "./elementNewsLink.css";

interface ElementNewsLinkProps {
  href: string;
  children?: ReactNode;
  onPress?: () => void;
}

const ElementNewsLink = ({ href, children, onPress }: ElementNewsLinkProps) => {
  const { opensInNewTab, externalSite, moreInfo } = usePlosTranslations();
  const isPremierLeagueLink = isPLLink(href);

  return (
    <Link
      className={elementNewsLinkStyles}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onPress={onPress}
      // onPress already tracks this click, so skip the generic outbound listener.
      data-track-click={onPress ? "manual" : undefined}
    >
      {children ?? moreInfo}
      {!isPremierLeagueLink && (
        <ExternalIcon className={externalLinkIcon} aria-hidden />
      )}
      <span className={visuallyHidden}>
        {`(${!isPremierLeagueLink ? `${externalSite}, ` : ""}${opensInNewTab})`}
      </span>
    </Link>
  );
};

export default ElementNewsLink;
